import notify from '@/api/notification'
import strings from '@/strings'
import analytics from '../../api/analytics'
import recollectService from '../../api/recollect'
import {
  RECOLLECT_CLEAR_ALL,
  RECOLLECT_INCREASE_OFFSET,
  RECOLLECT_SET_EXPAND_DETAILS,
  RECOLLECT_SET_LIST,
  RECOLLECT_SET_LOADING_STATUS_LIST,
  RECOLLECT_SET_LOADING_STATUS_TOTAL,
  RECOLLECT_SET_SEARCH_PARAMS,
  RECOLLECT_SET_TOTAL,
  RECOLLECT_PAGINATION_SET_TOTAL,
  RECOLLECT_SET_TOTAL_REALIZADO,
  RECOLLECT_SET_TOTAL_PENDENTE,
  RECOLLECT_SET_TOTAL_DISPENSADO,
  RECOLLECT_SET_CURRENT_TAB,
  RECOLLECT_SET_LOADING_STATUS_SUBMIT
} from '../types'

const state = {
  recollects: [],
  totalRecollectsForPagination: 0,
  loadingStatusList: 'STATUS_INITIAL',
  loadingStatusTotal: 'STATUS_INITIAL',
  patient: undefined,
  startDate: undefined,
  endDate: undefined,
  osLis: undefined,
  osAlvaro: undefined,
  status: 'PENDENTE',
  offset: 0,
  orderByProperty: 'createdAt',
  orderByDirection: 'asc',
  totalRecollects: 0,
  totalPendente: 0,
  totalRealizado: 0,
  totalDispensadoRecoletar: 0,
  currentTab: 1,
  loadingStatusSubmit: false,
  forceUpdatedInfiniteLoading: new Date()
}

const mutations = {
  [RECOLLECT_SET_LIST](state, recollects) {
    state.recollects = state.recollects.concat(recollects)
  },
  [RECOLLECT_SET_TOTAL](state, total) {
    state.totalRecollects = total
  },
  [RECOLLECT_PAGINATION_SET_TOTAL](state, total) {
    state.totalRecollectsForPagination = total
  },
  [RECOLLECT_SET_LOADING_STATUS_LIST](state, status) {
    state.loadingStatusList = status
  },
  [RECOLLECT_SET_LOADING_STATUS_TOTAL](state, status) {
    state.loadingStatusTotal = status
  },
  [RECOLLECT_SET_SEARCH_PARAMS](state, params) {
    state.patient = params.patient
    state.startDate = params.startDate
    state.endDate = params.endDate
    state.osLis = params.osLis
    state.osAlvaro = params.osAlvaro
    state.status = params.status
    state.orderByProperty = params.orderByProperty
    state.orderByDirection = params.orderByDirection
    state.previousDays = params.previousDays
    state.offset = params.offset
  },
  [RECOLLECT_CLEAR_ALL](state) {
    state.recollects = []
    state.loadingStatusList = 'STATUS_INITIAL'
    state.loadingStatusTotal = 'STATUS_INITIAL'
    state.offset = 0
  },
  [RECOLLECT_INCREASE_OFFSET](state) {
    state.offset++
  },
  [RECOLLECT_SET_EXPAND_DETAILS](state, requestId) {
    let index = state.recollects.findIndex(item => item.requestId === requestId)
    state.recollects[index].expanded = !state.recollects[index].expanded
  },
  [RECOLLECT_SET_TOTAL_REALIZADO](state, total) {
    state.totalRealizado = total
  },
  [RECOLLECT_SET_TOTAL_PENDENTE](state, total) {
    state.totalPendente = total
  },
  [RECOLLECT_SET_TOTAL_DISPENSADO](state, total) {
    state.totalDispensadoRecoletar = total
  },
  [RECOLLECT_SET_CURRENT_TAB](state, currentTab) {
    state.currentTab = currentTab
  },
  [RECOLLECT_SET_LOADING_STATUS_SUBMIT](state, status) {
    state.loadingStatusSubmit = status
  },
  RESET_RECOLLECT_STORE(state) {
    (state.patient = undefined),
    (state.startDate = undefined),
    (state.endDate = undefined),
    (state.osLis = undefined),
    (state.osAlvaro = undefined),
    (state.status = 'PENDENTE'),
    (state.offset = 0),
    (state.orderByProperty = 'createdAt'),
    (state.orderByDirection = 'asc'),
    (state.previousDays = 45),
    (state.recollects = []),
    (state.totalRecollects = 0),
    (state.totalPendente = 0),
    (state.totalRealizado = 0),
    (state.totalDispensadoRecoletar = 0),
    (state.currentTab = 1),
    (state.loadingStatusList = 'STATUS_INITIAL'),
    (state.loadingStatusTotal = 'STATUS_INITIAL'),
    (state.loadingStatusSubmit = false)
  },
  RECOLLECT_INCREASE_FORCE_UPDATED_INFINITE_LOADING() {
    state.forceUpdatedInfiniteLoading = +new Date()
  }
}

const getters = {
  recollectList: state => {
    return state.recollects
  },
  recollectListStatusLoading: state => {
    return state.loadingStatusList
  },
  isRecollectListStatusLoading: state => {
    return state.loadingStatusList === 'STATUS_LOADING'
  },
  isRecollectTotalStatusLoading: state => {
    return state.loadingStatusTotal === 'STATUS_LOADING'
  },
  totalRecollectsForPagination: state => {
    return state.totalRecollectsForPagination
  },
  recollectParans: state => {
    return {
      patient: state.patient,
      startDate: state.startDate,
      endDate: state.endDate,
      osLis: state.osLis,
      osAlvaro: state.osAlvaro,
      status: state.status,
      previousDays: state.previousDays,
      offset: state.offset,
      orderByProperty: state.orderByProperty,
      orderByDirection: state.orderByDirection
    }
  },
  totalRecollects: state => state.totalRecollects,
  totalRealizado: state => state.totalRealizado,
  totalPendente: state => state.totalPendente,
  totalDispensadoRecoletar: state => state.totalDispensadoRecoletar,
  recollectsCurrentTab: state => state.currentTab,
  isLoadingStatusSubmit: state => state.loadingStatusSubmit,
  recollectForceUpdatedInfiniteLoading: state => state.forceUpdatedInfiniteLoading,
  recollectOffest: state => state.offset
}

const actions = {
  async fetchRecollectList({ commit, state }, { reset = false } = {}) {
    if (reset) {
      commit(RECOLLECT_CLEAR_ALL)
    }

    commit(RECOLLECT_SET_LOADING_STATUS_LIST, 'STATUS_LOADING')

    const statusParsed = state.status === 'TODOS' ? '' : state.status
    const osAlvaroParsed = state.osAlvaro ? (isNaN(state.osAlvaro) ? undefined : state.osAlvaro) : undefined

    try {
      const response = await recollectService.getRecollects(
        state.patient,
        statusParsed,
        state.previousDays,
        state.offset,
        strings.listsLimits.recollect,
        state.orderByProperty,
        state.orderByDirection,
        state.osLis,
        osAlvaroParsed,
        state.startDate,
        state.endDate
      )

      const recollects = response.data.content

      commit(RECOLLECT_SET_LIST, recollects)
      commit(RECOLLECT_INCREASE_OFFSET)
      commit(RECOLLECT_PAGINATION_SET_TOTAL, response.data.totalPages - 1)

      if (recollects.length === strings.listsLimits.recollect) {
        commit(RECOLLECT_SET_LOADING_STATUS_LIST, 'STATUS_SUCCESS')
      } else {
        commit(RECOLLECT_SET_LOADING_STATUS_LIST, 'STATUS_END')
      }

      submitAnalyticsEvent(`Busca por ${state.status} - Últimos dias: ${state.previousDays}`)
    } catch (error) {
      commit(RECOLLECT_SET_LOADING_STATUS_LIST, 'STATUS_FAILED')
      commit(RECOLLECT_SET_LIST, [])
      commit(RECOLLECT_PAGINATION_SET_TOTAL, 0)

      if (error.response?.status !== 404) {
        notify({
          title: 'AVISO:',
          message: 'Erro ao carregar informações. Por favor, tente novamente.',
          action: {
            title: 'RECARREGAR',
            handler: reload
          }
        })
        submitAnalyticsEvent('Erro ao buscar listagem de recoletas')
      }
    }
  },

  async fetchRecollectListForSubmit({ dispatch, commit }) {
    commit(RECOLLECT_SET_LOADING_STATUS_SUBMIT, true)
    commit(RECOLLECT_CLEAR_ALL)
    try {
      commit('RECOLLECT_INCREASE_FORCE_UPDATED_INFINITE_LOADING')
      dispatch('getAllTotalRecollects')
    } finally {
      commit(RECOLLECT_SET_LOADING_STATUS_SUBMIT, false)
    }
  },

  async fetchRecollectListForTable({ dispatch }) {
    await dispatch('fetchRecollectList')
  },

  async getTotalRecollectsByStatus({ commit, state }, status) {
    commit(RECOLLECT_SET_LOADING_STATUS_TOTAL, 'STATUS_LOADING')

    const statusParsed =
      status === 'DISPENSADO' ? ['DISPENSADO_RECOLETAR', 'DISPENSADO_NOVA_OS'] : status == 'TODOS' ? [] : [status]

    const osAlvaroParsed = state.osAlvaro ? (isNaN(state.osAlvaro) ? undefined : state.osAlvaro) : undefined

    try {
      const response = await recollectService.getTotalRecollectsNumber(
        state.patient,
        statusParsed,
        state.previousDays,
        state.endDate,
        state.startDate,
        state.osLis,
        osAlvaroParsed
      )

      commit(RECOLLECT_SET_LOADING_STATUS_TOTAL, 'STATUS_SUCCESS')

      switch (status) {
        case 'TODOS':
          commit(RECOLLECT_SET_TOTAL, response.data)
          break
        case 'REALIZADO':
          commit(RECOLLECT_SET_TOTAL_REALIZADO, response.data)
          break
        case 'NAO_REALIZADO':
          commit(RECOLLECT_SET_TOTAL_PENDENTE, response.data)
          break
        case 'DISPENSADO':
          commit(RECOLLECT_SET_TOTAL_DISPENSADO, response.data)
          break
      }

      submitAnalyticsEvent(`Total de recoletas - sucesso [${status}]`)
    } catch (error) {
      commit(RECOLLECT_SET_LOADING_STATUS_TOTAL, 'STATUS_END')

      switch (status) {
        case 'TODOS':
          commit(RECOLLECT_SET_TOTAL, 0)
          break
        case 'REALIZADO':
          commit(RECOLLECT_SET_TOTAL_REALIZADO, 0)
          break
        case 'NAO_REALIZADO':
          commit(RECOLLECT_SET_TOTAL_PENDENTE, 0)
          break
        case 'DISPENSADO':
          commit(RECOLLECT_SET_TOTAL_DISPENSADO, 0)
          break
      }

      submitAnalyticsEvent(`Falha ao buscar total de Recoletas [${status}]`)

      if (error.response?.status !== 404) {
        commit(RECOLLECT_SET_LOADING_STATUS_TOTAL, 'STATUS_FAILED')
        notify({
          title: 'AVISO:',
          message: 'Erro ao carregar informações. Por favor, tente novamente.',
          action: {
            title: 'RECARREGAR',
            handler: reload
          }
        })
      }
    }
  },

  async getAllTotalRecollects({ dispatch }) {
    await dispatch('getTotalRecollectsByStatus', 'TODOS')
    await dispatch('getTotalRecollectsByStatus', 'REALIZADO')
    await dispatch('getTotalRecollectsByStatus', 'NAO_REALIZADO')
    await dispatch('getTotalRecollectsByStatus', 'DISPENSADO')
  },

  getRecollectByRequestId: function ({ dispatch }, requestId) {
    return new Promise(async (resolve, reject) => {
      let response = await recollectService.getRecollectByRequestId(requestId)
      response.data.exams.map(item => {
        item.id = item.examId
      })
      await dispatch('validateEditOSErros', response)
      resolve(response)
    })
  },

  dispenseRecollect: function ({ dispatch }, paramsList) {
    return new Promise(async (resolve, reject) => {
      let response = await recollectService.dispenseRecollect(paramsList)
      resolve(response)
    })
  },
  searchRecollect: function ({ dispatch }, paramsList) {
    return new Promise(async (resolve, reject) => {
      let response = await recollectService.searchRecollect(paramsList)
      resolve(response)
    })
  },
  expandRecollectDetails({ commit }, requestId) {
    commit(RECOLLECT_SET_EXPAND_DETAILS, requestId)
    submitAnalyticsEvent('Abrir detalhes da Recoleta')
  },
  clearAllRecollectData: function ({ commit }) {
    commit(RECOLLECT_CLEAR_ALL)
  },
  selectRecollectParams: function ({ commit }, paramsList) {
    commit(RECOLLECT_SET_SEARCH_PARAMS, paramsList)
  },
  setWaitingRecollectLoadingStatus: function ({ commit }) {
    commit(RECOLLECT_SET_LOADING_STATUS_LIST, 'STATUS_WAITING')
  },
  setCurrentTabRecollect: function ({ commit }, currentTab) {
    commit(RECOLLECT_SET_CURRENT_TAB, currentTab)
    commit('RECOLLECT_INCREASE_FORCE_UPDATED_INFINITE_LOADING')
  },
  resetRecollectStore({ commit }) {
    commit('RESET_RECOLLECT_STORE')
  }
}

const reload = function () {
  window.location.reload()
}

const submitAnalyticsEvent = action => {
  analytics.pushAnalyticsEvent('ga-event', {
    category: 'Recoletas',
    action: action
  })
}
export default {
  state,
  mutations,
  actions,
  getters
}
export { mutations, actions, getters }
